import { Tag } from "../types";

export const removeAccessTokenFromUrl = () => {
  const { search } = location;

  history.replaceState({}, "", search);
};

/* user can no longer copy/paste token on accident or leak via airplay */
export const ifElse = (condition: boolean, then: any, otherwise: any) =>
  condition ? then : otherwise;

export const formatTags = (tags: string[]): Tag[] =>
  tags.map((tag: string) => {
    const { name, category } = getTagName(tag);
    return {
      title: name,
      number: 0,
      selected: false,
      disabled: false,
      category: category,
      shared: false,
    };
  });

export const getTagName = (tag: string) => {
  let category = tag.split("-")[0];
  let name = tag.split("-").splice(1).join("-");
  return { name: name ? name : category, category: name ? category : "other" };
};

export const getTagId = (title: string, category: string) => {
  return category === "other" ? title : `${category}-${title}`;
};

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * Math.floor(max));
};

export const tagsGenerator = (index: number, length: number) => {
  const deployment = [
    "Segment-Density-Online",
    "Segment-Not-Installed",
    "Segment-Uninstalled",
  ];

  const geo = [
    "Geo-Africa",
    "Geo-Asia",
    "Geo-Caribbean",
    "Geo-Central-America",
    "Geo-Europe",
    "Geo-North-America",
    "Geo-Oceania",
    "Geo-South-America",
  ];

  const segment = [
    "Segment-Consulting",
    "Segment-Audit",
    "Segment-Tax",
    "Segment-Sales",
    "Segment-Marketing",
  ];

  const status = ["Status-Open", "Status-Closed"];

  const type = ["Type-Suburban", "Type-Urban"];

  const metro = [
    "Metro-Jacksonville",
    "Metro-Houston",
    "Metro-Oklahoma-City",
    "Metro-Nashville",
    "Metro-Los-Angeles",
    "Metro-San-Antonio",
    "Metro-New-York",
    "Metro-Dallas",
    "Metro-Miami",
    "Metro-Seattle",
    "Metro-Portland",
    "Metro-San-Francisco",
    "Metro-Boston",
    "Metro-Chicago",
    "Metro-Ottawa",
    "Metro-Montreal",
    "Metro-Vancouver",
    "Metro-San-Jose",
    "Metro-San-Diego",
    "Metro-New-Orleans",
    "Metro-Indianapolis",
    "Metro-Atlanta",
    "Metro-Charlotte",
    "Metro-Austin",
    "Metro-Kansas-City",
    "Metro-Denver",
    "Metro-Detroit",
  ];

  const oa = ["OA-Candidate"];

  let tags: string[] = [];

  tags.push(deployment[index % deployment.length]);
  tags.push(geo[index % geo.length]);
  tags.push(segment[index % segment.length]);
  tags.push(status[index % status.length]);
  tags.push(type[index % type.length]);
  tags.push(metro[index % metro.length]);
  tags.push(oa[index % oa.length]);

  return tags;
};

export const dataGenerator = (index: number) => {
  const names = [
    "Taylor Swift",
    "Jennifer Aniston",
    "George Clooney",
    "Robert Downey Jr.",
    "Miley Cyrus",
    "Julia Roberts",
    "Britney Spears",
    "Natalie Portman",
    "Oprah Winfrey",
    "Jennifer Lawrence",
    "Kim Kardashian",
    "Alec Baldwin",
    "Beyoncé",
    "Emma Stone",
    "Scarlett Johansson",
    "Emma Watson",
    "Mila Kunis",
    "Chris Hemsworth",
    "Rachel McAdams",
    "Lindsay Lohan",
    "Demi Moore",
    "Tom Hanks",
    "Amanda Seyfried",
    "Rihanna",
    "Sarah Michelle Gellar",
    "Katy Perry",
    "Alyson Hannigan",
    "David Hasselhoff",
    "Jenna Fischer",
    "Justin Bieber",
    "Ellen DeGeneres",
    "Jay-Z",
    "Dwayne Johnson",
    "Tom Cruise",
    "Cristiano Ronaldo",
    "Sean Combs",
    "Drake",
    "Angelina Jolie",
    "Brad Pitt",
    "Will Smith",
    "Madonna",
    "Matt Damon",
    "Jennifer Lopez",
    "Steven Spielberg",
    "David Beckham",
    "Elton John",
    "Johnny Depp",
    "Ben Affleck",
    "Halle Berry",
    "Serena Williams",
    "Chrissy Teigen",
    "Justin Timberlake",
    "Leonardo DiCaprio",
    "Selena Gomez",
    "Meryl Streep",
    "Ariana Grande",
    "Channing Tatum",
    "Ryan Reynolds",
    "Nicole Kidman",
    "Reese Witherspoon",
    "Demi Lovato",
    "Mariah Carey",
    "Nicki Minaj",
    "Eminem",
    "Sandra Bullock",
    "Khloé Kardashian",
    "Chris Pratt",
    "Denzel Washington",
    "Kevin Hart",
    "Barack Obama",
    "Adam Sandler",
    "Gwyneth Paltrow",
    "John Legend",
    "Kourtney Kardashian",
    "Jessica Alba",
    "Jamie Foxx",
    "Will Ferrell",
    "Daniel Craig",
    "Katie Holmes",
    "Alex Rodriguez",
    "Paris Hilton",
    "Arnold Schwarzenegger",
    "Kevin Durant",
    "Ashton Kutcher",
    "Harrison Ford",
    "Simon Cowell",
    "Vanessa Hudgens",
    "Marilyn Monroe",
    "Heidi Klum",
    "Jennifer Garner",
    "Nick Jonas",
    "Cara Delevingne",
    "Hilary Duff",
    "Jimmy Fallon",
    "Harry Styles",
    "Matthew McConaughey",
    "Tiger Woods",
    "Mark Wahlberg",
    "Elvis Presley",
    "Michael Jordan",
    "Michael Jackson",
    "Bruce Lee",
    "K.S. Chithra",
    "Morgan Freeman",
    "Chuck Norris",
    "Al Pacino",
    "Beyonce Knowles",
    "Christian Bale",
    "Nelson Mandela",
    "Leonardo Di Caprio",
    "Marlon Brando",
    "James Hetfield",
    "Freddie Mercury",
    "Whitney Houston",
    "Jackie Evancho",
    "James Brown",
    "Muhammad Ali",
    "Christopher Reeves",
    "Neil Armstrong",
    "Robert De Niro",
    "Jesus Christ",
    "Sachin Tendulkar",
    "Shakira",
    "Lady GaGa",
    "Jackie Chan",
    "Sarah Geronimo",
    "Bono",
    "Chester Bennington",
    "Amy Lee",
    "Debby Ryan",
    "Tim Burton",
    "Ronnie James Dio",
    "Marilyn Monroe",
    "Albert Einstein",
    "Diana, Princess of Wales",
    "Kanye West",
    "Robin Williams",
    "Nicolas Cage",
    "Jim Carrey",
    "Audrey Hepburn",
    "Jack Nicholson",
    "Bruce Willis",
    "Vin Diesel",
    "Elizabeth Taylor",
    "Howard Stern",
    "Kobe Bryant",
    "Jerry Seinfeld",
    "Charlize Theron",
    "Blake Lively",
    "Cameron Diaz",
    "Megan Fox",
    "Kate Beckinsale",
    "Nina Dobrev",
    "Kate Hudson",
    "Salma Hayek",
    "Amber Heard",
    "Sofía Vergara",
    "Anne Hathaway",
    "Jessica Biel",
    "Keira Knightley",
    "Hayden Panettiere",
    "Olivia Wilde",
    "Eva Longoria",
    "Eva Mendes",
    "Jennifer Love Hewitt",
    "Kristen Stewart",
    "Julianne Hough",
    "Penélope Cruz",
    "Zac Efron",
    "Ryan Gosling",
    "Hugh Jackman",
    "Liam Hemsworth",
    "Jake Gyllenhaal",
    "Chris Pine",
    "Robert Pattinson",
    "Ian Somerhalder",
    "Adam Levine",
    "Jared Leto",
    "Taylor Lautner",
    "Joseph Gordon-Levitt",
    "Keanu Reeves",
    "Daniel Radcliffe",
    "Orlando Bloom",
    "Kellan Lutz",
    "Zayn Malik",
    "Joe Manganiello",
    "James Franco",
    "Chace Crawford",
    "Jamie Dornan",
    "Alex Pettyfer",
    "Gerard Butler",
    "Logan Lerman",
    "Jude Law",
    "Andrew Garfield",
    "Heath Ledger",
    "Wentworth Miller",
    "Chad Michael Murray",
    "Colin Farrell",
    "Shia LaBeouf",
    "Paul Walker",
    "Jared Padalecki",
    "Milo Ventimiglia",
    "Kristen Bell",
    "Drew Barrymore",
    "Carrie Fisher",
    "Alicia Keys",
    "Emily Blunt",
    "Zooey Deschanel",
    "Carrie Underwood",
  ];

  const streetTypes = [
    "Street",
    "Road",
    "Drive",
    "Blvd.",
    "Way",
    "Highway",
    "Ave",
    "Lane",
    "Parkway",
    "Alley",
  ];

  const directions = [
    "North",
    "South",
    "East",
    "West",
    "South",
    "North",
    "West",
    "North",
    "South",
    "East",
    "West",
    "West",
  ];

  const geoMetros: any = {
    "Geo-Midwest": [
      "Metro-Chicago",
      "Metro-Cleveland",
      "Metro-Columbus",
      "Metro-Detroit",
      "Metro-St-Louis",
      "Metro-Pittsburgh",
    ],
    "Geo-Northeast": ["Metro-Boston", "Metro-New-York", "Metro-Philadelphia"],
    "Geo-South-Central": ["Metro-Austin", "Metro-Dallas", "Metro-Houston"],
    "Geo-Southern-California": [
      "Metro-Los-Angeles",
      "Metro-Phoenix",
      "Metro-San-Diego",
    ],
  };

  // build street name
  // 30% of time they have a North/South/East/West

  const direction = directions[index % directions.length] + " ";

  let street = names[index];
  let streetType = streetTypes[index % streetTypes.length];
  let streetNumber = index * index - 10 * index + 60;

  return `${streetNumber} ${direction}${street} ${streetType}`;
};
